import React, { useState, useEffect } from 'react';
import './ColumnConfig.css'
import '../../Pages/Mix/Transaction/MixMaster.css'
import GlidGrid from '../../Components/Grid/GlidGrid';
import { GetColumnconfig } from '../../Asset/httpMethod';
import { useDispatch, useSelector } from 'react-redux';
import { addData, deleteData, fetchData, updateData } from '../../Redux/Slices/Utility/ColumnConfigSlice';
import { confirmPopup, GridActionButton } from '../../Asset/common';
import Loader from './Loader';
import { Accordion, Modal } from 'react-bootstrap';
import { FaCheck } from 'react-icons/fa6';
import useAutoAdjustHeight from '../../Components/useAutoAdjustHeight/useAutoAdjustHeight.js';
import { fetchDataNew, addData as DynamicAdd } from '../../Redux/Slices/Transaction/DynamicSlice.js';

function ColumnConfigComp(props) {

  let { MenuCode } = props;
  const [GetViewPara, setGetViewPara] = useState([])
  const [ColumnConfigData, setColumnConfigData] = useState([])
  const [AUTHUSERCOLUMN, setAUTHUSERCOLUMN] = useState([])
  const dispatch = useDispatch()
  let ColumnConfigData_Alldata = useSelector(state => state.ColumnConfig.all);
  let [AllData, setAllData] = useState(ColumnConfigData_Alldata)

  const [isAuthModal, setisAuthModal] = useState(false);
  const [AuthUserData, setAuthUserData] = useState([]);
  const [SelectedUsers, setSelectedUsers] = useState([]);
  const [SelectedMenuCode, setSelectedMenuCode] = useState("");
  const [SelectedColName, setSelectedColName] = useState("");

  const getAllData = () => {
    dispatch(fetchData())
    Columnconfig()
    setAUTHUSERCOLUMN(ColumnConfigData_Alldata?.filter((x) => x.MenuCode == 'AUTHUSER'))
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      getAllData();
    }, 300);
    return () => clearTimeout(timer);
  }, [MenuCode]);


  useEffect(() => {
    if (AllData?.length > 0 && GetViewPara.length > 0) {
      setTimeout(() => {
        const firstInput = document.querySelector('input');
        if (firstInput) firstInput.focus();
      }, 500);
    }
  }, [AllData, GetViewPara]);

  const gridHeight = useAutoAdjustHeight();

  useEffect(() => {
    if (MenuCode === undefined) {
      setAllData(ColumnConfigData_Alldata);
    } else {
      setAllData(ColumnConfigData_Alldata?.filter(x => x.MenuCode === MenuCode));
    }
  }, [ColumnConfigData_Alldata, MenuCode]);

  const Columnconfig = async () => {
    let ColumnConfig = ColumnConfigData_Alldata?.filter(x => x.MenuCode === "COLUMNCONFIG");

    if (MenuCode === undefined) {
      setColumnConfigData(ColumnConfigData_Alldata);
    } else {
      let ColumnConfigData = await GetColumnconfig(MenuCode);
      setAllData(ColumnConfigData_Alldata?.filter(x => x.MenuCode === MenuCode));
      setColumnConfigData(ColumnConfigData);
    }
    
    setGetViewPara(ColumnConfig);
  };

  const editdata = (type, dataRow) => {
    if (type === "edit") {
      dispatch(updateData(dataRow)).then(() => {
        dispatch(fetchData());
      });
    } else {
      dispatch(addData(dataRow)).then(() => {
        dispatch(fetchData());
      });
    }
  };



  const Delete = (dataRow) => {
    let res = confirmPopup()
    if (res === true) {
      dispatch(deleteData(dataRow))
      dispatch(fetchData())
    }
  }

  const getActionButton = (dataRow, columnKey) => {
    if (columnKey?.toLowerCase() === "edit") {
      return {
        ...GridActionButton.EditButton,
        onClick: () => editdata(columnKey?.toLowerCase(), dataRow)
      };
    }

    else if (columnKey?.toLowerCase() === "delete") {
      return {
        ...GridActionButton.DeleteButton,
        onClick: () => Delete(dataRow)
      };
    }
    else if (columnKey?.toLowerCase() === "addnew") {
      return {
        ...GridActionButton.AddButton,
        onClick: () => editdata(columnKey?.toLowerCase(), dataRow)
      };
    }
    else {
      return undefined;
    }
  };

  const loadData = () => {
    getAllData()
  }

  // const fetchUserData = async (rowData) => {
  //   try {

  //     setSelectedMenuCode(rowData.MenuCode);
  //     setSelectedColName(rowData.ColName);
  //     const ObjJson = {
  //       jsonObj1: [{}],
  //       SPName: "API_GetUsersDet"
  //     };

  //     const res = await fetchDataNew(ObjJson);
  //     setAuthUserData(res);
  //     setisAuthModal(true);
  //   } catch (error) {
  //     console.error("Error fetching offer count data:", error);
  //   }
  // };

  const fetchUserData = async (rowData) => {
    try {
      setSelectedMenuCode(rowData.MenuCode);
      setSelectedColName(rowData.ColName);

      const ObjJson = {
        jsonObj1: [{}],
        SPName: "API_GetUsersDet"
      };

      const res = await fetchDataNew(ObjJson);


      // Convert AuthUsers string into an array, trim spaces
      const authUserArray = rowData.AuthUsers
        ? rowData.AuthUsers.split(",").map(user => user.trim())
        : [];

      // Mark SELECTED as true if username is in AuthUsers list
      const updatedRes = res.map(user => ({
        ...user,
        SELECTED: authUserArray.includes(user.USERNAME)
      }));

      setAuthUserData(updatedRes);
      setisAuthModal(true);
    } catch (error) {
      console.error("Error fetching offer count data:", error);
    }
  };


  const handleDoubleClick = (rowData, column) => {
    if (column === 'AuthUsers') {
      fetchUserData(rowData);
    };
  }

  const GetselectedRow = (Selected) => {
    ;

    // Convert AuthUserData into a map
    const userMap = new Map(AuthUserData.map(u => [u.USERNAME, u]));

    // Override with whatever comes from Selected
    Selected.forEach(sel => {
      userMap.set(sel.USERNAME, { ...userMap.get(sel.USERNAME), ...sel });
    });

    // Only keep SELECTED true
    const merged = [...userMap.values()].filter(u => u.SELECTED);

    setSelectedUsers(merged);
  };

  const UpdateAuthUser = async () => {
    
    const transformedObj = {
      USERNAME: SelectedUsers?.map(u => u.USERNAME).join(",") || '',
      MENUCODE: SelectedMenuCode,
      COLNAME: SelectedColName
    };

    let ObjJsonDet = {
      jsonObj1: transformedObj,
      SPName: "API_AuthUserUpdate"
    };

    await dispatch(DynamicAdd(ObjJsonDet)).then(() => {
      setAuthUserData([]);
      setisAuthModal(false);
    });

  };

  return (
    <>
      <Loader />
      <div className='gridTopHeight'>
        <div className='accoridonContent'>
          <Accordion style={{ width: '100%' }}>
            <Accordion.Item className='p-2'>
              <div className='d-flex justify-content-between align-items-center'>
                <div className='col-12 justify-content-end d-flex align-items-start text-lg-end'>
                  <button className='savepanelBtn btn-primary' onClick={() => loadData()}>
                    <FaCheck size={17} /> Show
                  </button>
                </div>
              </div>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      <div className='col-12 col-md-12 p-1 border border-1 rounded'>
        {
          AllData?.length > 0 && GetViewPara.length > 0 &&
          <GlidGrid
            key={AllData.length} // or use Date.now() if you want a new key each time
            data={AllData}
            columns={GetViewPara}
            // height={"650px"}
            height={`${gridHeight}px`}
            ActionButton={getActionButton}
            AddNewRecord={true}
            ViewparaName={"COLUMNCONFIG"}
            onCellDoubleClicked={handleDoubleClick}
          />
        }
      </div>

      <Modal
        show={isAuthModal}
        onHide={() => setisAuthModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ Width: '2000px', margin: 'auto' }}
        dialogClassName="custom-modal modalwidth"
      >
        <Modal.Body>
          {
            AUTHUSERCOLUMN && AUTHUSERCOLUMN?.length > 0 && <GlidGrid
              data={AuthUserData}
              columns={AUTHUSERCOLUMN}
              height={`${gridHeight}px`}
              GetselectedRow={GetselectedRow}
              ExcelGet={"AUTHUSER"}
              ViewparaName={"AUTHUSER"}
            />
          }
        </Modal.Body>
        <Modal.Footer>
          <button
            variant="secondary"
            className="savepanelBtn btn-primary"
            onClick={() => UpdateAuthUser()}
          >
            Save
          </button>
          <button
            variant="secondary"
            className="savepanelBtn btn-primary"
            onClick={() => setisAuthModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default ColumnConfigComp;
